export default {
  // Sync
  SET_CHAT_REQUEST_COUNTER: "SET_CHAT_REQUEST_COUNTER",
  SET_CHAT_REQUESTS: "SET_CHAT_REQUESTS",
  SET_START_ALL_DATA: "SET_START_ALL_DATA",
  UPDATE_ALL_DATA: "UPDATE_ALL_DATA",
  SET_START_CHAT_USERS: "SET_START_CHAT_USERS",
  UPDATE_CHAT_USERS: "UPDATE_CHAT_USERS",
  SET_CHAT_DIALOG_STATUS: "SET_CHAT_DIALOG_STATUS",
  SET_ROOM_SKIP_NUM: "SET_ROOM_SKIP_NUM",
  SET_ROOMS_VIEW_STATUS: "SET_ROOMS_VIEW_STATUS",
  UPDATE_RED_DOT: "UPDATE_RED_DOT",
};
